import _ from 'lodash'

/**
 * @type {RoutesVuexState}
 */
const initialState = {
    currentRoute: null,
    routeStack: [],
}

/**
 * @type {RoutesVuexState}
 */
const state = _.cloneDeep(initialState)

export { initialState }

export default state
